import { Flex } from 'components'
import LayoutEditor from './LayoutEditor'
import LayoutTree from './LayoutTree'
import LayoutViewer from './LayoutViewer'
import TemplateLayoutProvider from './TemplateLayoutProvider'

interface Props {
  initialRootLayoutKey?: number
}

export default function ManageTemplateLayout({ initialRootLayoutKey }: Props) {
  return (
    <TemplateLayoutProvider>
      <Flex gap={4} flex={1} overflow="hidden">
        <LayoutTree initialRootLayoutKey={initialRootLayoutKey} />
        <LayoutViewer />
        <LayoutEditor />
      </Flex>
    </TemplateLayoutProvider>
  )
}
